import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
/* eslint-disable @typescript-eslint/naming-convention */
@Component({
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    standalone: false
})
export class LoadingIndicatorComponent {

    @Input() loading: boolean = false;
    @Input() inline: boolean = false;
    @Input() useWholeViewPort: boolean = false;
    @Input() overlayActive: boolean = false;
    @Input() styleClass: string | object = null;
    @Input() overlayStyleClass: string | object = null;
    @Input() dotStyleClass: string | object = null;
    @Input() lightMode: boolean = false;
    @Input() smallIndicator: boolean = false;
    @Input() loadingMessage: string;

    /**
   * Generates the internal version of the style class,
   * which needs to always have a few classes regardless of what
   * is set from the outside
   */
    get internalStyleClass(): string | object {

        let styleClass: string |object = {
            'loadingIndicator--inline': this.inline,
            'loadingIndicator--fixed': !this.inline && this.useWholeViewPort,
            'loadingIndicator--light': this.lightMode,
            'loadingIndicator--withMessage': this.loadingMessage
        };

        if(typeof this.styleClass === 'object') {

            styleClass = {
                ...styleClass,
                ...this.styleClass
            };

        } else if(typeof this.styleClass === 'string') {

            styleClass = this.styleClass;

            if(this.inline) {

                styleClass += ' loadingIndicator--inline';

            } else {
                if (this.useWholeViewPort) {
                    styleClass += ' loadingIndicator--fixed';
                }

            }

            if (this.lightMode) {
                styleClass += ' loadingIndicator--light';
            }

        }

        return styleClass;

    };

    /**
   * Generates the internal version of the overlay style class,
   * which needs to always have a few classes regardless of what
   * is set from the outside
   */
    get internalOverlayStyleClass(): string | object {

        let styleClass: string | object = {
            'loadingOverlay--active': this.overlayActive,
            'useWholeViewPortClass' : this.useWholeViewPort
        };

        if(typeof this.overlayStyleClass === 'object') {

            styleClass = {
                ...styleClass,
                ...this.overlayStyleClass
            };

        } else if(typeof this.overlayStyleClass === 'string') {

            styleClass = this.overlayStyleClass;

            if(this.overlayActive) {

                styleClass += ' loadingOverlay--active';

            }

            if (this.useWholeViewPort) {
                styleClass += ' useWholeViewPortClass';
            }

        }

        return styleClass;

    };

}
